export const readCookie = (name: string) => {
    const cookie = document.cookie
        .split('; ')
        .find(key => key.startsWith(`${name}=`))
    return cookie ? cookie.split('=')[1] : null
}

